<template>
  <div class="my-3 d-flex shortcut-container justify-content-between d-md-none">
    <div class="d-flex flex-column align-items-center" @click="showContractionModal()">
      <contraction-svg></contraction-svg>
      <span>+ Contraction</span>
    </div>
    <div class="d-flex flex-column align-items-center" @click="showDreamLogPopup">
      <dream-svg></dream-svg>
      <span>+ Dream</span>
    </div>
    <router-link to="/meditation_dashboard">
      <div class="d-flex flex-column align-items-center">
        <meditation-svg></meditation-svg>
        <span>+ Meditation</span>
      </div>
    </router-link>
    <div class="d-flex flex-column align-items-center" @click="showDailyLogPopup">
      <dailylog-svg></dailylog-svg>
      <span>+ Daily log</span>
    </div>

    <b-modal id="modal-add-contraction" title="Add your contraction" hide-header hide-footer>

      <div class="d-flex flex-column">

        <b-form-textarea
          v-model="contraction"
          placeholder="Add your contraction"
          rows="6"
          class="mt-2"
          autofocus
        ></b-form-textarea>

        <div class="mt-3">
          <b-button class="btn btn-sm text-decoration-none" @click="saveContraction" :disabled="loading.save">
            Submit <b-spinner small v-if="loading.save"></b-spinner>
          </b-button>
          <b-button size="sm" variant="outline-secondary" @click="hideContractionPopup()">
            Close
          </b-button>
        </div>
      </div>

    </b-modal>
  </div>
</template>

<script>

import axios from 'axios';
import EventBus from "@/bus";
import ContractionSvg from "@/components/svg/ContractionSvg";
import DreamSvg from "@/components/svg/DreamSvg";
import MeditationSvg from "@/components/svg/MeditationSvg";
import DailylogSvg from "@/components/svg/DailylogSvg";

export default {
  components: {DailylogSvg, MeditationSvg, DreamSvg, ContractionSvg},
  data() {
    return {
      contraction: '',
      loading: {
        save: false,
      }
    }
  },

  methods: {
    showDailyLogPopup() {
      EventBus.$emit('showDailyLogPopup')
    },

    showDreamLogPopup() {
      EventBus.$emit('showDreamLogPopup')
    },

    showContractionModal() {
      this.$bvModal.show('modal-add-contraction');
    },

    hideContractionPopup() {
      this.$bvModal.hide('modal-add-contraction');
    },

    saveContraction() {

      if (! this.contraction) {
        return
      }

      const params = new URLSearchParams();
      params.append("token", this.$store.state.session_id);
      params.append("contraction", this.contraction);

      this.loading.save = true
      axios({
        method: "post",
        url: this.$store.state.api_url + "contractions/store",
        data: params,
      })
        .then(() => {
          this.contraction = ''
          this.loading.save = false
          this.hideContractionPopup()
        })
    }
  }
}

</script>

<style scoped>

.shortcut-container {
  gap: 4px;
  color: #d6b674;
  font-size: 9px;
}

.shortcut-container > div {
  cursor: pointer;
}

a {
  color: #d6b674;
}

a:hover {
  color: #d6b674;
  text-decoration: none;
}

</style>
